/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Gl_15_TInputs */

const en_tut_gl_15_t = /** @type {(inputs: Tut_Gl_15_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcript`)
};

const id_tut_gl_15_t = /** @type {(inputs: Tut_Gl_15_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transkrip`)
};

/**
* | output |
* | --- |
* | "Transcript" |
*
* @param {Tut_Gl_15_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_gl_15_t = /** @type {((inputs?: Tut_Gl_15_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Gl_15_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_gl_15_t(inputs)
	return en_tut_gl_15_t(inputs)
});